import { connect } from "react-redux";
import Home from "./Home";

export default connect((store) => ({ categories: store.localstore.filter_category || [] }))(Home);
